var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.1722L16.243 8.92917C16.6335 8.5387 17.2665 8.5387 17.657 8.92917C18.0475 9.31963 18.0475 9.9527 17.657 10.3432L12.7071 15.2931C12.3166 15.6836 11.6834 15.6836 11.2929 15.2931L6.34299 10.3432C5.95252 9.9527 5.95252 9.31963 6.34299 8.92917C6.73345 8.5387 7.36652 8.5387 7.75699 8.92917L12 13.1722Z",
    fill: "#A8ABAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownGrey);
export default __webpack_public_path__ + "static/media/icon-chevron-down-grey.59d72f099741f5cd216bb353929e26fc.svg";
export { ForwardRef as ReactComponent };